export const PAYROLLCOMPONENTDETAIL_LOADING = "PAYROLLCOMPONENTDETAIL_LOADING";
export const PAYROLLCOMPONENTDETAIL_RESET = "PAYROLLCOMPONENTDETAIL_RESET";
export const GET_PAYROLLCOMPONENTDETAIL = "GET_PAYROLLCOMPONENTDETAIL";
export const GET_PAYROLLCOMPONENTDETAIL_SUCCESS = "GET_PAYROLLCOMPONENTDETAIL_SUCCESS";
export const GET_PAYROLLCOMPONENTDETAIL_FAIL = "GET_PAYROLLCOMPONENTDETAIL_FAIL";
export const DELETE_PAYROLLCOMPONENTDETAIL = "DELETE_PAYROLLCOMPONENTDETAIL"
export const DELETE_PAYROLLCOMPONENTDETAIL_SUCCESS = "DELETE_PAYROLLCOMPONENTDETAIL_SUCCESS"
export const DELETE_PAYROLLCOMPONENTDETAIL_FAIL = "DELETE_PAYROLLCOMPONENTDETAIL_FAIL"
export const UPDATE_PAYROLLCOMPONENTDETAIL = "UPDATE_PAYROLLCOMPONENTDETAIL"
export const UPDATE_PAYROLLCOMPONENTDETAIL_SUCCESS = "UPDATE_PAYROLLCOMPONENTDETAIL_SUCCESS"
export const UPDATE_PAYROLLCOMPONENTDETAIL_FAIL = "UPDATE_PAYROLLCOMPONENTDETAIL_FAIL"
export const ADD_NEW_PAYROLLCOMPONENTDETAIL = "ADD_NEW_PAYROLLCOMPONENTDETAIL"
export const ADD_PAYROLLCOMPONENTDETAIL_SUCCESS = "ADD_PAYROLLCOMPONENTDETAIL_SUCCESS"
export const ADD_PAYROLLCOMPONENTDETAIL_FAIL = "ADD_PAYROLLCOMPONENTDETAIL_FAIL"